/**
 * 一个缓存handler
 * Q.什么时候会触发reload? A.默认根据调用参数的不同决定，自定义请使用`options.getKey`
 * @template Result
 * @template Args
 * @param {(...args: Args) => Result} resolver
 * @param {UseMemoizeOptions<Args>} [options]
 * @return {*}
 */
export function useMemoize(resolver, options) {
    const cache = new Map()
    /**
     * 返回缓存的结果
     */
    const memoized = (...args) => {
        const key = generateKey(...args)
        if (cache.has(key)) {
            return cache.get(key)
        }
        return _loadData(key, ...args)
    }
    const loadData = (...args) => _loadData(generateKey(...args), ...args)

    const deleteData = (...args) => {
        cache.delete(generateKey(...args))
    }
    const clearData = () => {
        cache.clear()
    }
    /**
     * 缓存结果
     */
    function _loadData(key, ...args) {
        cache.set(key, resolver(...args))
        return cache.get(key)
    }
    /**
     * 从参数生成key
     */
    const generateKey = (...args) =>
        options?.getKey
            ? options.getKey(...args)
            : // Default key: Serialize args
              JSON.stringify(args)

    memoized.load = loadData
    memoized.delete = deleteData
    memoized.clear = clearData
    memoized.cache = cache

    return memoized
}
